import { useQuery } from "@tanstack/react-query"
import { client, APIError } from "@/api"

export interface PendingRegistration {
  id: number
  email: string
  created_at: string
  expires_at: string
  is_expired: boolean
  completion_url: string
}

interface PendingRegistrationsResponse {
  pendingRegistrations: PendingRegistration[]
}

export function usePendingRegistrations() {
  return useQuery<PendingRegistrationsResponse>({
    queryKey: ["admin", "pending-registrations"],
    queryFn: async () => {
      const response = await (client.admin as any)["pending-registrations"].$get()
      if (!response.ok) {
        const error = (await response.json()) as any
        throw new APIError(
          response.status,
          error.code || "FETCH_PENDING_REGISTRATIONS_FAILED",
          new Error(error.message || "Failed to fetch pending registrations")
        )
      }
      const data = (await response.json()) as PendingRegistrationsResponse
      return {
        pendingRegistrations: data.pendingRegistrations ?? [],
      }
    },
  })
}
